import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";

/**
 * A field value on an active proposal that opens something — a document, a team member's profile.
 *
 * Black and underlined, the same as `RowLink` on the draft, archived and work agreement pages. It was
 * `info.main`, which is MUI's `#0288d1` — exactly `lightBlue[700]`, the blueline color — so every
 * plain link read as a change the viewer had made (#5814). Blue belongs to the bluelined part alone:
 * the diff spans inside the link color that part, and give it an underline of its own, because the
 * link's underline is drawn in the link's color whatever its children's color is.
 */
const ProposalInfoLink = styled(Link)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.primary,
  cursor: "pointer",
  textDecorationColor: theme.palette.text.primary,
}));

export default ProposalInfoLink;
